import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import AppContext from "../../context/app/context";
import {useNavigate} from "react-router-dom";
import DonationServiceContext from "../../context/donation-service/context";
import {useIsMount} from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import DonationServiceTable from "../../components/donation-service/donation-service-table";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import {Button, Divider} from "antd";
import Can from "../../utils/rbac/can";
import {CAN_VIEW_HOME_PAGE} from "../../utils/rbac/permissions";
import {PlusOutlined} from "@ant-design/icons";
import PageHeader from "../../components/general/layout/page-header";
import SearchFilterCard from "../../components/general/filter-card";
import DonationServiceContextProvider from "../../context/donation-service/provider";
import DonationServiceFilter from '../../components/donation-service/donation-service-filter'
interface IProps {
    children?: React.ReactNode;
}

const DonationService: React.FC<IProps> = (props) => {
    const {t} = useTranslation();
    const {direction} = useContext(AppContext);
    const navigate = useNavigate();

    const [search, setSearch] = useState<string | undefined>(undefined);
    const {actions, loading, query} = useContext(DonationServiceContext);

    useEffect(() => {
        actions.setSearch(search);
    }, [search]);

    const isMounted = useIsMount();
    useEffect(() => {
        !isMounted && actions.getData();
    }, [query, direction]);

    return (
        <div dir={direction} className={styles.container}>
            <PageHeader
                title={t("donation_services")}
                subTitle={t("donation_services")}
                extra={[
                    <RefreshBtn
                        key={0}
                        loading={loading.includes("list")}
                        onClick={() => actions.getData()}
                    >
                        {t("refresh")}
                    </RefreshBtn>,
                    <Divider key={1} type="vertical"/>,
                    <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
                            <Button
                            type="primary"
                            onClick={() => navigate(`/donation-service/create`)}
                            icon={<PlusOutlined/>}
                        >
                            {t("add_donation_service")}
                        </Button>
                    </Can>,
                ]}
            />
            <SearchFilterCard
                formId="donation-service-filter"
                searchValue={search}
                setSearchValue={setSearch}
                onReset={() => actions.setQuery({
                    page: query?.page,
                    perPage: query?.perPage,
                })}
                resetLoading={loading.includes("list")}
                applyLoading={loading.includes("list")}
            >
                <DonationServiceFilter/>
            </SearchFilterCard>
            <DonationServiceTable/>
        </div>
    )
}

const DonationServicePage = () => {
    return (
        <DonationServiceContextProvider>
            <DonationService/>
        </DonationServiceContextProvider>
    );
};
export default DonationServicePage;